import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";
import { resolveExchangeRate } from "./resolveExchangeRate.js";

export function convertPriceToCzk(price: number, sourceCurrency: Currency, exchangeRates: ExchangeRate[]): number {
	return roundToPlaces(price * resolveExchangeRate(sourceCurrency, exchangeRates), 2);
}
